import { LINE_ITEM_VISUALIZATION_TYPE } from '@pperform/pp-constants/widgetConfigs';
import { BaseProductImage } from './ProductImage.styles';
import { SHAPES, SIZES } from './ProductImage.constants';

interface ProductImageProps {
  src: string;
  lineItemConfig: {
    visualisationType: string;
  };
  size?: SIZES;
  alt?: string;
}

export const ProductImage = ({
  lineItemConfig,
  size = SIZES.md,
  src,
  alt,
}: ProductImageProps): JSX.Element => {
  const shape =
    lineItemConfig.visualisationType === LINE_ITEM_VISUALIZATION_TYPE.TILE_VIEW
      ? SHAPES.square
      : SHAPES.rounded;
  return <BaseProductImage src={src} shape={shape} size={size} alt={alt} />;
};
